<template>
  <vs-popup
    title="Selecionar Mês e Ano"
    :active.sync="localActive"
    class="modal-select-month-year"
    @mousedown.native.stop
    @click.native.stop
  >
    <div class="w-full" @mousedown.stop @click.stop>
      <!-- Year navigation -->
      <div class="flex items-center justify-between mb-6 px-4">
        <vs-button
          color="primary"
          type="border"
          icon="chevron_left"
          @click="prevYear"
        ></vs-button>
        <span class="text-2xl font-bold">{{ selectedYear }}</span>
        <vs-button
          color="primary"
          type="border"
          icon="chevron_right"
          @click="nextYear"
        ></vs-button>
      </div>

      <!-- Month grid -->
      <div class="grid-months">
        <div
          v-for="(mes, index) in meses"
          :key="index"
          class="month-item"
          :class="{ 'active': selectedMonth === index }"
          @click="selectMonth(index)"
        >
          {{ mes }}
        </div>
      </div>

      <!-- Footer -->
      <div class="flex justify-center mt-6 w-full">
        <vs-button class="w-full justify-center" color="success" type="filled" @click="confirmSelection">
          Selecionar
        </vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: "ModalSelectMonthYear",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    initialMonth: {
      type: Number,
      default: new Date().getMonth(),
    },
    initialYear: {
      type: Number,
      default: new Date().getFullYear(),
    },
  },
  data() {
    return {
      meses: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ],
      selectedMonth: new Date().getMonth(),
      selectedYear: new Date().getFullYear(),
    };
  },
  computed: {
    localActive: {
      get() {
        return this.active;
      },
      set(val) {
        this.$emit("update:active", val);
      },
    },
  },
  watch: {
    active(newVal) {
      if (newVal) {
        this.selectedMonth = this.initialMonth;
        this.selectedYear = this.initialYear;
      }
    },
  },
  methods: {
    prevYear() {
      this.selectedYear--;
    },
    nextYear() {
      this.selectedYear++;
    },
    selectMonth(index) {
      this.selectedMonth = index;
    },
    confirmSelection() {
      this.$emit("selected", {
        month: this.selectedMonth,
        year: this.selectedYear,
      });
      this.localActive = false;
    },
  },
};
</script>

<style scoped>
.modal-select-month-year {
  z-index: 100000;
}
.grid-months {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  padding: 10px;
}
.month-item {
  text-align: center;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  font-weight: 500;
}
.month-item:hover {
  background-color: #f5f5f5;
  border-color: #primary; /* fallback if missing */
}
.month-item.active {
  background-color: rgb(var(--vs-primary));
  color: white;
  border-color: rgb(var(--vs-primary));
}
</style>
